import React, { useEffect } from 'react'
import { ToolBar } from '../components/ToolBar'
import { Container } from 'react-bootstrap'
import { Footer } from '../components/Footer';

export function Page(props) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      <div className={props.home ? "home" : ""} >
      <ToolBar home={props.home ? true : false}/>
      <Container className='d-flex mt-4 justify-content-center' style={{ minHeight: 'calc(100vh - 130px)' }}>
        {props.children}
      </Container>
      </div>
      <Footer home={props.home ? true : false}/>
    </div>
  );
}